import { create } from 'zustand'

import {
  getFallbackLocale,
  getMotionPreference,
  setLocalePreference as persistLocalePreference,
  setMotionPreference as persistMotionPreference,
} from '@/services/cookies'
import type { Locale, MotionPreference } from '@/types/site'

type UiState = {
  localePreference: Locale
  isMenuOpen: boolean
  isNavbarPinned: boolean
  motionPreference: MotionPreference
  setLocalePreference: (locale: Locale) => void
  openMenu: () => void
  closeMenu: () => void
  toggleMenu: () => void
  setNavbarPinned: (value: boolean) => void
  setMotionPreference: (value: MotionPreference) => void
  reset: () => void
}

export const createInitialUiState = () => ({
  localePreference: getFallbackLocale(),
  isMenuOpen: false,
  isNavbarPinned: false,
  motionPreference: getMotionPreference(),
})

export const useUiStore = create<UiState>((set) => ({
  ...createInitialUiState(),
  setLocalePreference: (locale) => {
    persistLocalePreference(locale)
    set({ localePreference: locale })
  },
  openMenu: () => set({ isMenuOpen: true }),
  closeMenu: () => set({ isMenuOpen: false }),
  toggleMenu: () => set((state) => ({ isMenuOpen: !state.isMenuOpen })),
  setNavbarPinned: (value) => set({ isNavbarPinned: value }),
  setMotionPreference: (value) => {
    persistMotionPreference(value)
    set({ motionPreference: value })
  },
  reset: () => set(createInitialUiState()),
}))
